// English translations for the admin-pages area, keyed by the Russian source string.
export default {
  // Common / shared terms
  'Код': 'Code',
  'Вес': 'Weight',
  'Цена': 'Price',
  'Дата': 'Date',
  'регистрации': 'registration',
  'Статус': 'Status',
  'Действие': 'Action',
  'Тип': 'Type',
  'Отправитель': 'Sender',
  'Получатель': 'Receiver',
  'Филиал': 'Branch',
  'Филиалы': 'Branches',
  'Номер': 'Number',
  'Название': 'Name',
  'Примечание': 'Note',
  'Описание': 'Description',
  'Количество': 'Quantity',
  'Поиск': 'Search',
  'Назад': 'Back',
  'Да': 'Yes',
  'Нет': 'No',
  'Отмена': 'Cancel',
  'Сохранить': 'Save',
  'Удалить': 'Delete',
  'Добавить': 'Add',
  'Изменить': 'Change',
  'Редактировать': 'Edit',
  'Просмотр': 'View',
  'Подробнее': 'Details',
  'Всего': 'Total',
  'Экспорт': 'Export',
  'Нет данных': 'No data',
  'Предупреждение': 'Warning',
  'Произошла ошибка': 'An error occurred',
  'Все': 'All',
  'Без имени': 'No name',
  'Успешно скопировано': 'Copied successfully',

  // Cargo / shipment types
  'Груз': 'Cargo',
  'Авиагруз': 'Air cargo',
  'Наземный груз': 'Ground cargo',
  'Express груз': 'Express cargo',
  'Контейнерный груз': 'Container cargo',
  'Показать контейнерный груз': 'Show container cargo',
  'Добавить груз': 'Add cargo',

  // Payment
  'Оплата': 'Payment',
  'Тип оплаты': 'Payment type',
  'Наличные': 'Cash',
  'Перевод': 'Transfer',
  'Карта': 'Card',
  'Кыргызстан': 'Kyrgyzstan',
  'Оплачено в Кыргызстане': 'Paid in Kyrgyzstan',
  'Оплата в США': 'Payment in USA',
  'Оплата в Кыргызстане': 'Payment in Kyrgyzstan',
  'Детали оплаты': 'Payment details',
  'Сумма': 'Amount',
  'Общая сумма': 'Total amount',

  // Orders list
  'В США': 'In USA',
  'В Кыргызстане': 'In Kyrgyzstan',
  'Отправлено из США': 'Shipped from USA',
  'Прибыло в Кыргызстан': 'Arrived in Kyrgyzstan',
  'Архив': 'Archive',
  'Трек': 'Track',
  'Нет трека': 'No track',
  'Доставлено': 'Delivered',
  'Всего треков': 'Total tracks',
  'Пакет': 'Package',
  'Партия': 'Batch',
  'Партии': 'Batches',
  'Доставка курьером': 'Courier delivery',
  'Получает SMS': 'Receives SMS',
  'Получает эл. почту': 'Receives email',
  'Отметить как выданное': 'Mark as issued',
  'Отправления': 'Shipments',
  'Отправление': 'Shipment',
  'Номер трека': 'Tracking number',
  'Номера треков': 'Tracking numbers',
  'Искать по номеру': 'Search by number',
  'Ссылка успешно скопирована!': 'Link copied successfully!',
  'Не удалось скопировать ссылку!': 'Failed to copy link!',
  'Отправитель не найден': 'Sender not found',
  'Получатель не найден': 'Receiver not found',

  // Order details
  'SMS-уведомления включены!': 'SMS notifications enabled!',
  'SMS-уведомления отключены!': 'SMS notifications disabled!',
  'Эл. почта включена!': 'Email enabled!',
  'Эл. почта отключена!': 'Email disabled!',
  'Не удалось скачать этикетку': 'Failed to download the label',
  'Печать...': 'Printing...',
  'Не удалось напечатать этикетку./nПроверьте IP-адрес принтера!': 'Failed to print the label./nCheck the printer IP address!',
  'Вес и цена изменены': 'Weight and price updated',
  'Цена изменена': 'Price updated',
  'Номер трека успешно добавлен': 'Tracking number added successfully',
  'Номер трека успешно изменён': 'Tracking number updated successfully',
  'Успешно удалено': 'Deleted successfully',
  'Статус успешно изменён': 'Status changed successfully',
  'Дата регистрации': 'Registration date',
  'Дата получения': 'Date received',
  'Вы уверены, что хотите удалить этот номер трека?': 'Are you sure you want to delete this tracking number?',
  'Дата доставки успешно сохранена!': 'Delivery date saved successfully!',
  'Подробная информация об отправлении': 'Detailed shipment information',
  'Код подтверждения': 'Confirmation code',
  'Получать SMS': 'Receive SMS',
  'Получать эл. почту': 'Receive email',
  'Вы уверены, что хотите изменить статус отправления?': 'Are you sure you want to change the shipment status?',
  'Готово к отправке': 'Ready to ship',
  'Скачать этикетку': 'Download label',
  'Печать этикетки': 'Print label',
  'Разделить отправление': 'Split shipment',
  'Выдано': 'Issued',
  'Тип отправления': 'Shipment type',
  'Страна получения': 'Destination country',
  'Филиал получения': 'Pickup branch',
  'Информация о доставке': 'Delivery information',
  'Адрес доставки': 'Delivery address',
  'Адрес доставки отсутствует': 'No delivery address',
  'Комментарий клиента': 'Customer comment',
  'Дата доставки (время Улан-Батора)': 'Delivery date (Ulaanbaatar time)',
  'Сохранить дату доставки': 'Save delivery date',
  'Содержимое отправления': 'Shipment contents',
  'Комментарий администратора': 'Administrator comment',
  'Комментарий администратора успешно изменён': 'Administrator comment updated successfully',
  'Вы уверены, что хотите отменить это отправление?': 'Are you sure you want to cancel this shipment?',
  'Добавить трек': 'Add track',
  'Новый номер трека': 'New tracking number',
  'Введите номер трека!': 'Enter a tracking number!',
  'Редактировать номер трека': 'Edit tracking number',
  'Разделить': 'Split',
  'Выберите номера треков для разделения отправления': 'Select tracking numbers to split the shipment',
  'Новое отправление': 'New shipment',
  'Ваш груз успешно разделён.': 'Your cargo was split successfully.',
  'Изменить статус трека': 'Change track status',
  'Редактировать отправление': 'Edit shipment',

  // Customs
  'Таможня': 'Customs',
  'Показать завершённые таможни': 'Show completed customs',
  'Код, отправитель, получатель': 'Code, sender, receiver',
  'Создать таможню': 'Create customs',
  'Список партий': 'Batch list',
  'Список отправлений': 'Shipment list',
  'Успешно создано!': 'Successfully created!',
  'Успешно сохранено!': 'Successfully saved!',
  'Успешно сохранено': 'Successfully saved',
  'Партия успешно добавлена': 'Batch added successfully',
  'Не удалось скачать': 'Download failed',
  'Подробности таможни': 'Customs details',
  'Подробная информация о таможне': 'Detailed customs information',
  'Введите дату!': 'Enter a date!',
  'Введите AirBill No!': 'Enter AirBill No!',
  'Получить отчёт': 'Get report',
  'Создать партию': 'Create batch',
  'Добавить отправление': 'Add shipment',
  'Информация о таможне': 'Customs information',

  // Shipments / batches
  'Общий вес отправлений': 'Total shipment weight',
  'Количество пакетов': 'Package count',
  'Скачать отчёт': 'Download report',
  'Партия успешно создана!': 'Batch created successfully!',
  'Переход на страницу партии': 'Navigating to the batch page',
  'Не удалось скачать отчёт': 'Failed to download report',
  'Показать архивные партии': 'Show archived batches',
  'Список пакетов': 'Package list',
  "Статус всех заказов, относящихся к этому отправлению, станет 'Отложено'. Продолжить?":
    "The status of all orders in this shipment will become 'Delayed'. Continue?",
  'Есть неупакованные отправления. Продолжить?': 'There are unpacked shipments. Continue?',
  'Информация о партии успешно изменена!': 'Batch information updated successfully!',
  'Пакет успешно создан!': 'Package created successfully!',
  'Вы уверены, что хотите убрать это отправление?': 'Are you sure you want to remove this shipment?',
  'Убрать': 'Remove',
  'Отправление успешно убрано!': 'Shipment removed successfully!',
  'Вы уверены, что хотите убрать этот пакет?': 'Are you sure you want to remove this package?',
  'Пакет успешно убран!': 'Package removed successfully!',
  'Не удалось убрать: в пакете есть отправления!': 'Could not remove: the package contains shipments!',
  'Опустошите пакет и попробуйте снова!': 'Empty the package and try again!',
  'Общий вес': 'Total weight',
  'Количество коробок': 'Box count',
  'Дата доставки': 'Delivery date',
  'Партия успешно удалена': 'Batch deleted successfully',
  'Партия - Подробнее': 'Batch - Details',
  'Подробная информация о партии': 'Detailed batch information',
  'Общий вес груза': 'Total cargo weight',
  'Выберите филиал!': 'Select a branch!',
  'Список доставки': 'Delivery list',
  'Поиск по названию, типу U-Post': 'Search by name, U-Post type',
  'Создать пакет': 'Create package',
  'Название пакета': 'Package name',
  'подробная информация': 'detailed information',

  // Boxes
  'Коробка': 'Box',
  'Название пакета успешно изменено!': 'Package name updated successfully!',
  'Отправление не найдено!': 'Shipment not found!',

  // Bulk orders
  'Заказ': 'Order',
  'Заказы': 'Orders',
  'Заказчик': 'Customer',
  'Массовый заказ': 'Bulk order',
  'Количество треков': 'Track count',
  'Количество отправлений': 'Shipment count',
  'Вы уверены, что хотите удалить это массовое отправление?': 'Are you sure you want to delete this bulk shipment?',
  'Массовое отправление успешно удалено!': 'Bulk shipment deleted successfully!',
  'Невозможно удалить непустое массовое отправление!': 'Cannot delete a non-empty bulk shipment!',
  'Массовые отправления': 'Bulk shipments',
  'Массовое отправление': 'Bulk shipment',
  'Не получено': 'Not received',
  'Информация о треках': 'Tracking information',
  'Введите дополнительное описание': 'Enter additional description',

  // Reports
  'Отчёт': 'Report',
  'Общее': 'General',
  'Авиаотправления': 'Air shipments',
  'Наземные отправления': 'Ground shipments',
  'Получено в США': 'Received in USA',
  'Получено в Кыргызстане': 'Received in Kyrgyzstan',
}
